import { Sprite } from '@pixi/react'
import { Assets, Sprite as PixiSprite } from 'pixi.js'
import { useEffect, useRef, useState } from 'react'
import { app } from '../util/index'

interface LoadingProps {
  x: number
  y: number
  width: number
  height: number
}

export const Loading = (props: LoadingProps) => {
  const spriteRef = useRef<PixiSprite>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const image = 'Loading'

    setIsLoading(true)

    const exists = Assets.cache.has(image.toString())
    if (!exists) {
      console.warn('Image not found in assets cache:', image, ' ,starting to load it.')
      Assets.load(image).then(() => {
        setIsLoading(false)
      })
    }
    else {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    if (!isLoading) {
      const callback = (delta: number) => {
        if (spriteRef.current)
          spriteRef.current.rotation += 0.1 * delta
      }

      app.ticker.add(callback)
      return () => {
        app?.ticker?.remove(callback)
      }
    }
  }, [isLoading])

  if (isLoading) return null

  return (
    <Sprite ref={spriteRef} anchor={0.5} x={props.x} y={props.y} width={props.width} height={props.height} image="Loading" />
  )
}
